import type { User } from '../../domain/user';

export const postAuthStatus = (isAuthenticated: boolean): void => {
  window.parent.postMessage({ message: 'user authentication', isAuthenticated }, '*');
};

export const postEmailAgentFeatureStatus = (user: User): void => {
  window.parent.postMessage(
    { message: 'craft email agent feature', isEnabled: user.isCraftEmailAgentFeatureEnabled },
    '*'
  );
};
